import { Component, Input, Output, EventEmitter } from '@angular/core';

import { User } from '@core/services/user';

import { ContactSummary } from '../../../models/contactsummary';

@Component({
  selector: 'spark-contacts-contact-list-item',
  templateUrl: './contact-list-item.component.html',
  styleUrls: ['./contact-list-item.component.scss']
})
export class ContactListItemComponent {
  @Input()
  contact!: ContactSummary;

  @Input()
  user: User | undefined;

  @Input()
  isNavigatable: boolean = false;

  @Output()
  clicked: EventEmitter<ContactSummary> = new EventEmitter<ContactSummary>();

  constructor() {}

  public onClick(contact: ContactSummary): void {
    this.clicked.emit(contact);
  }

  public get adviserName() {
    return this.user?.displayName || '';
  }
}
